import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08a60953"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a60953')) {
      api.createRecord('08a60953', component.options)
    } else {
      api.reload('08a60953', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08a60953", function () {
      api.rerender('08a60953', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Pruebas/index.vue"
export default component.exports